interface Slide {
    src: string;
    title: string;
  }
  
  const Slides: Slide[] = [
    { src: "/assets/Photography/1.jpeg", title: "Look at this cat" },
    { src: "/assets/Photography/2.jpeg", title: "Look at this cat" },
    { src: "/assets/Photography/3.jpeg", title: "Chao" },
    { src: "/assets/Photography/4.jpeg", title: "Beatrice" },
    { src: "/assets/Photography/5.jpeg", title: "New Home" },
    { src: "/assets/Photography/6.jpeg", title: "They Kinda do" },
    { src: "/assets/Photography/7.jpeg", title: "They Kinda do" },
    { src: "/assets/Photography/8.jpeg", title: "They Kinda do" },
    { src: "/assets/Photography/9.jpeg", title: "They Kinda do" },
    { src: "/assets/Photography/10.jpeg", title: "They Kinda do" },
    { src: "/assets/Photography/11.jpeg", title: "They Kinda do" },
    { src: "/assets/Photography/12.jpeg", title: "They Kinda do" },
  ];
  
  export default Slides;
  